/**
 * @author Huangxiaoxun<hxx09448@gmail.com>
 * @date 2018/11/23
 */

const ConsultAssistant = resolve =>
  require(['../../../views/consult/ConsultAssistant'], resolve)

const SetHalfPrice = resolve =>
  require(['../../../views/consult/SetHalfPrice'], resolve)

const ConsultLetter = resolve =>
  require(['../../../views/consult/ConsultLetter'], resolve)

const setMoneyOff = resolve =>
  require(['../../../views/consult/setMoneyOff'], resolve)

const EditPriceList = resolve =>
  require(['../../../views/consult/EditPriceList'], resolve)

const setCalendar = resolve =>
  require(['../../../views/consult/setCalendar'], resolve)

const setCalendarTimeSpace = resolve =>
  require(['../../../views/consult/setCalendarTimeSpace'], resolve)

const setPreConsult = resolve =>
  require(['../../../views/consult/setPreConsult'], resolve)

const setServices = resolve =>
  require(['../../../views/consult/setServices'], resolve)

export default [
  {
    path: '/consult-assistant',
    component: ConsultAssistant
  },
  {
    path: '/set-half-price',
    component: SetHalfPrice,
    meta: {
      title: '半价活动'
    }
  },
  {
    path: '/consult-letter',
    component: ConsultLetter,
    meta: {
      title: '给初次体验咨询的你一封信'
    }
  },
  {
    path: '/set-money-off',
    component: setMoneyOff
  },
  {
    path: '/edit-price-list',
    component: EditPriceList,
    meta: {
      pageName: '历史改价记录',
      business: '咨询'
    }
  },
  {
    path: '/set-calendar',
    component: setCalendar
  },
  {
    path: '/set-calendar-time-space',
    component: setCalendarTimeSpace
  },
  {
    path: '/set-preconsult',
    component: setPreConsult
  },
  {
    path: '/set-services',
    component: setServices
  }
]



// WEBPACK FOOTER //
// ./src/router/page/consult/equipment.js